<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6ftO6i/tc-custom/9798337200064.jpg?1734012362394" alt="This image is the cover for the book Sisters"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sisters
      </h1>
      <p class="bookDescription body article font2">
        <b>From the author of <i>Girl Out of Sight</i>, this gripping, tense novel tells the story of a drowned child, estranged sisters, and a home steeped in sorrow . . .</b><br/><br/> Rachel thought she could outrun her past. But when her sister Imogen returns home after years abroad, the walls Rachel has built around herself begin to crumble.<br/><br/> Two decades after the tragic loss of their baby brother, Rachel has constructed a life that appears perfect on the surface. A successful career, a loving daughter, and a claim on her parents’ beautiful family home, the Old Rectory.<br/><br/> Imogen’s arrival rips open old wounds and exposes the cracks in Rachel’s façade. Once a carefree nomad, Imogen is now destitute and desperate, determined to reclaim her place in the family. Imogen wants what she believes is hers—no matter the cost.<br/><br/> Now, as secrets resurface, danger looms, and bonds are tested, the only thing more dangerous than the past is the silence that has kept it hidden . . .<br/><br/><i>The Sisters </i>is a gripping tale of mourning, guilt, and the deadly consequences of unspoken truths.<br/><br/><i>Previously published under the title </i>Façade.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Helen Matthews
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?059f3dad